import { api } from "../utils/api";
import type {
  RestCreatePrepStation,
  RestPrepStation,
  RestUpdatePrepStation,
} from "@KassaroAB/shared/types/prepStation";
import type { PrepStationId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const prepStationsPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "prepStations");

export const getPrepStationsApi = (
  scope: CatalogScope,
): Promise<RestPrepStation[]> => {
  return api.get(prepStationsPath(scope));
};

export const getPrepStationApi = (
  scope: CatalogScope,
  prepStationId: PrepStationId,
): Promise<RestPrepStation> => {
  return api.get(`${prepStationsPath(scope)}/${prepStationId}`);
};

export const createPrepStationApi = (
  scope: CatalogScope,
  prepStation: RestCreatePrepStation,
): Promise<RestPrepStation> => {
  return api.post(prepStationsPath(scope), prepStation);
};

export const updatePrepStationApi = (
  scope: CatalogScope,
  prepStationId: PrepStationId,
  prepStation: RestUpdatePrepStation,
): Promise<RestPrepStation> => {
  return api.put(`${prepStationsPath(scope)}/${prepStationId}`, prepStation);
};

export const deletePrepStationApi = (
  scope: CatalogScope,
  prepStationId: PrepStationId,
): Promise<void> => {
  return api.delete(`${prepStationsPath(scope)}/${prepStationId}`);
};
